import styled from "styled-components";
import { scrollbars } from "theme/mixins";

const Scroller = styled.div<{ fixedWidth?: number }>`
  width: ${(props) => (props.fixedWidth ? `${props.fixedWidth}px` : "100%")};
  overflow: auto;
  position: relative;
  ${scrollbars()}
`;

export default Scroller;
